var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 34.3636C27.0374 34.3636 34.3636 27.0374 34.3636 18C34.3636 8.96261 27.0374 1.63636 18 1.63636C8.9626 1.63636 1.63635 8.96261 1.63635 18C1.63635 27.0374 8.9626 34.3636 18 34.3636Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09094 30.2727V29.0727C7.09094 24.4636 11.9728 20.7273 18 20.7273C24.0273 20.7273 28.9091 24.4636 28.9091 29.0727V30.2727",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.6364C21.0124 16.6364 23.4545 14.1943 23.4545 11.1818C23.4545 8.16936 21.0124 5.72727 18 5.72727C14.9875 5.72727 12.5454 8.16936 12.5454 11.1818C12.5454 14.1943 14.9875 16.6364 18 16.6364Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.015cf611177ecf257f5dec920f922101.svg";
export { ForwardRef as ReactComponent };